import React from "react";
import { useDispatch } from "react-redux";

import { BaseURL, getCookie } from "../components/Common";

import cds_terms from "../assets/cds_terms.pdf";
import lysaght_terms from "../assets/lysaght_terms.pdf";

import { makeStyles } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";

import { CircularProgress } from "@material-ui/core";
import { blue } from "@material-ui/core/colors";

import { loadUser } from "../redux_store/appState";
import { FULL_API_BASES, TEST_API_BASES } from "../AppConfig";

const useStyles = makeStyles({
    avatar: {
        backgroundColor: blue[100],
        color: blue[600],
    },
    paper: {
        width: "600px",
        overflow: "hidden",
    },
    paper2: {
        width: "600px",
        overflow: "hidden",
    },
    message: {
        width: "100%",
        textAlign: "center",
        color: "red",
    },
});

export default function SimpleDialog(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [loading, setloading] = React.useState(false);

    let _loading = loading;
    const [password, setPassword] = React.useState("Diegodiego1");
    const [email, setEmail] = React.useState("diego.portela@bluescopesteel.com.lld.bbccomms");
    const [passwordHelper, setPasswordHelper] = React.useState(
        window.tokenexpired ? "Token expired. Please login..." : ""
    );

    const [SF_user, setSF_user] = React.useState(false);
    const [loaded, setLoaded] = React.useState(false);

    React.useEffect(() => {
        // if ((window.debug && window.location.href.includes("static")) || window.location.href.includes("use_cache"))
        //     return;
        if (window.loading_user) return;
        let cds_token = getCookie("CDS_token");

        if (cds_token && SF_user) {
            window.loading_user = true;
            dispatch(loadUser(SF_user, "cent2021")).then((result) => {
                if (!result) {
                    setTimeout(function () {
                        dispatch(loadUser(SF_user, "cent2021")).then((result) => {
                            if (!result) {
                                setloading(false);
                                setPasswordHelper(
                                    "Could not load user '" + SF_user + "' from Salesforce... try again."
                                );
                                setSF_user(false);
                                window.loading_user = false;
                            } else if (result.Error) {
                                setPasswordHelper(result.Error);
                                setloading(false);
                                window.loading_user = false;
                            }
                        });
                    }, 2000);
                    // setloading(false);
                    // setPasswordHelper("Could not load user '" + SF_user + "' from Salesforce... try again.");
                    // setSF_user(false);
                    // window.loading_user = false;
                } else if (result.Error) {
                    setPasswordHelper(result.Error);
                    setloading(false);
                    window.loading_user = false;
                }
            });
        }
    }, [SF_user]);

    React.useEffect(() => {
        if (!loaded) {
            setLoaded(true);
            setSF_user(getCookie("SF_user"));
            // if (window.debug) login("kevinchan@qikdraw.com.au", "cent2021");
        }
    }, [loaded]);

    const login = (_email, _password) => {
        setPasswordHelper("");
        setloading(_email);
        if (!_password) {
            setPasswordHelper("please set a password");
            return;
        }
        if (!_email) {
            setPasswordHelper("please set an email");
            return;
        }
        dispatch(loadUser(_email, _password)).then((result) => {
            if (!result) {
                setloading(false);
                setPasswordHelper("Could not load user '" + _email + "' from Salesforce... try again.");
            }
            if (result.Error) {
                setPasswordHelper(result.Error);
                setloading(false);
            }
        });
    };

    const CDS_token = getCookie("CDS_token");
    //  const SF_user_email = getCookie("SF_user");

    const salesForce = (brand) => {
        if (window.debug) {
            localStorage.clear();
        }
        const brand_extra = brand === "Lysaght" ? "?b=Lysaght" : "";
        let redirect = "/auth/" + brand_extra;
        if (window.location.href.startsWith("http://localhost:3000"))
            redirect = "http://localhost:62027/auth" + brand_extra;
        if (process.env.REACT_APP_TEST_API === "true") {
            if (brand === "Lysaght") {
                redirect = TEST_API_BASES["Lysaght"];
            } else {
                redirect = TEST_API_BASES["default"];
            }
            redirect = redirect.slice(0, -4) + "auth/" + brand_extra;
        }
        window.location.href = redirect;
    };

    if (!loaded) {
        return <></>;
    } else if (CDS_token && SF_user) {
        return (
            <Dialog aria-labelledby="simple-dialog-title" open={true} classes={{ paper: classes.paper2 }}>
                <DialogTitle id="simple-dialog-title">
                    Load {window.test || window.debug ? "TEST " : ""}Account
                </DialogTitle>
                <List>
                    <ListItem
                        button
                        onClick={() => {
                            salesForce();
                        }}
                        key={"Salesforce"}
                    >
                        <ListItemAvatar>
                            <Avatar className={classes.avatar}>
                                <CircularProgress style={{ zIndex: 1 }} />
                                <div
                                    style={{
                                        position: "absolute",
                                    }}
                                >
                                    <img src={BaseURL("/images/salesforce_logo.png")} style={{ width: "100%" }} />
                                </div>
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary={"Loading Account (" + SF_user + ")..."} />
                    </ListItem>
                </List>
            </Dialog>
        );
    } else {
        //DES-1754
        if (!window.debug && !window.location.href.includes("init-beta")) {
            salesForce();
            _loading = true;
        }

        return (
            <Dialog aria-labelledby="simple-dialog-title" open={true} classes={{ paper: classes.paper }}>
                <DialogTitle id="simple-dialog-title">Load Account</DialogTitle>
                {passwordHelper && <div className={classes.message}>{passwordHelper}</div>}
                {/* <TextField
              id="filled-email-input"
              label="Email"
              type="text"
              // autoComplete="current-password"
              variant="filled"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
              id="filled-password-input"
              label="Demo Password"
              type="password"
              autoComplete="current-password"
              variant="filled"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              helperText={passwordHelper}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  login(email, password);
                }
              }}
            />
            <List>
              <ListItem button onClick={() => {
                // if (password !== "cent2020") {
                //   setPasswordHelper("password incorrect");
                //   return;
                // };
                login(email, password);
              }
              } key={"Fielders Test User"}>
                <ListItemAvatar>
                  <Avatar className={classes.avatar}>
                    {loading ? <CircularProgress style={{ zIndex: 1 }} /> : ""}<AccountCircleIcon style={{
                      position: 'absolute',
                    }} />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary={"Login"} />
              </ListItem>
               */}

                <List>
                    <ListItem
                        button
                        onClick={() => {
                            salesForce();
                        }}
                        key={"Salesforce"}
                    >
                        <ListItemAvatar>
                            <Avatar className={classes.avatar}>
                                {_loading ? <CircularProgress style={{ zIndex: 1 }} /> : ""}
                                <div
                                    style={{
                                        position: "absolute",
                                    }}
                                >
                                    <img src={BaseURL("/images/salesforce_logo.png")} style={{ width: "100%" }} />
                                </div>
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary={"Login with Salesforce"} />
                    </ListItem>
                    {window.debug && (
                        <ListItem
                            button
                            onClick={() => {
                                salesForce("Lysaght");
                            }}
                            key={"lysaght"}
                        >
                            <ListItemAvatar>
                                <Avatar className={classes.avatar}>
                                    {_loading ? <CircularProgress style={{ zIndex: 1 }} /> : ""}
                                    <AccountCircleIcon
                                        style={{
                                            position: "absolute",
                                        }}
                                    />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={"Login with Salesforce (Lysaght)"} />
                        </ListItem>
                    )}
                </List>
                <div
                    style={{
                        padding: "10px",
                        width: "100%",
                        textAlign: "center",
                        fontSize: "small",
                    }}
                >
                    <a href="https://cdn.dcs.bluescope.com.au/download/bluescope-privacy-policy" target="_blank">
                        Privacy Policy
                    </a>{" "}
                    |{" "}
                    <a href={window.FIELDERS ? cds_terms : lysaght_terms} target="_blank">
                        Terms of Use
                    </a>{" "}
                    |{" "}
                    <a
                        href={
                            window.FIELDERS
                                ? "https://fielders.com.au/wp-content/uploads/Fielders-terms-conditions.pdf"
                                : window.LYSAGHT
                                ? "https://cdn.dcs.bluescope.com.au/download/lysaght-sales-terms-and-conditions.pdf"
                                : "https://fielders.com.au/wp-content/uploads/Fielders-terms-conditions.pdf"
                        }
                        target="_blank"
                    >
                        Terms and Conditions
                    </a>{" "}
                </div>
            </Dialog>
        );
    }
}
